import { makeZeroArgHook } from "../../utils/makeZeroArgHook";
import getAccountGroupsV4, { url } from "../requests/getAccountGroupsV4";
export const accountGroupsV4KeyMaker = () => [url()];
const useGetAccountGroupsV4 = makeZeroArgHook(getAccountGroupsV4, accountGroupsV4KeyMaker);
export default useGetAccountGroupsV4;
//# sourceMappingURL=useGetAccountGroupsV4.js.map